import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LOGO from '@assets/images/logo.png';

interface AppLogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  variant?: 'sidebar' | 'header' | 'login';
  onClick?: () => void;
}

const AppLogo = memo(({ size = 'medium', showText = true, variant = 'header', onClick }: AppLogoProps) => {
  const theme = useTheme();
  const sizeConfig = {
    small: { width: 24, height: 24, fontSize: 14 },
    medium: { width: 32, height: 32, fontSize: 16 },
    large: { width: 40, height: 40, fontSize: 20 },
  };

  const config = sizeConfig[size];

  const logoTextStyles = {
    fontWeight: 'bold',
    fontSize: config.fontSize,
    // In dark mode force white; in light mode keep previous variant-based behavior
    color: theme.palette.mode === 'dark' ? theme.palette.common.white : variant === 'sidebar' ? '#000' : 'white',
    display: 'flex',
    alignItems: 'center',
    // gap: 0.5,
  } as const;

  const harbourTextStyles = {
    fontWeight: 'bold',
    color: 'primary.main',
    fontSize: config.fontSize,
  };

  const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: showText ? 1.5 : 0,
    transition: 'all 0.3s ease',
    cursor: onClick ? 'pointer' : 'default',
    ...(onClick && {
      '&:hover': {
        opacity: 0.8,
      },
    }),
    ...(variant === 'login' && {
      position: 'absolute' as const,
      top: 32,
      left: 32,
    }),
  };

  return (
    <Box onClick={onClick} sx={containerStyles}>
      {/* Logo Image */}
      <Box
        sx={{
          width: config.width,
          height: config.height,
          borderRadius: variant === 'login' ? 2 : 1.5,
          // ...(variant === 'login' && { backgroundColor: 'primary.main' }),
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        <img
          src={LOGO}
          alt="GAME OPS Logo"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>

      {/* Logo Text */}
      {showText && (
        <Typography sx={logoTextStyles} component="div">
          GAME.
          <Typography sx={harbourTextStyles} component="span">
            OPS
          </Typography>
        </Typography>
      )}
    </Box>
  );
});

export default AppLogo;
